import React, { useState, useEffect } from "react";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch } from "react-redux";
import FilterDropDown from "../../../../../ReusableComponents/FilterDropDown/FilterDropDown";
import LicenceTypePopUp from "./UpdateLicTypePopUp";
import { setAppError } from "./../../../../../store/userSlice";

export default function ListDrivingLicenceApplys({
  token,
  titles = [],
  list = [],
  callBack,
  selectedStatus,
  setSelectedStatus,
  selectVisaProvider,
  setSelectVisaProvider,
  filter,
  setFiltered,
}) {
  const [searchWords, setSearchWords] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [Popup, setPopUp] = useState(false);

  //filter

  const [datalist, SetListData] = useState([]);

  const dispatch = useDispatch();

  const onChangeValue = (e) => {
    const clientStatus = e.target.value;
    console.log("Selected Client:", clientStatus);
    setSelectedStatus(clientStatus);

    // if (!clientStatus && !selectVisaProvider) {
    //   setFiltered([]);
    //   return;
    // }

    // const filteredData = list.filter((indexData) => {
    //   if (clientStatus && selectVisaProvider) {
    //     return (
    //       indexData.client_name === clientStatus &&
    //       indexData.visa_provider === selectVisaProvider
    //     );
    //   } else if (clientStatus) {
    //     return indexData.client_name === clientStatus;
    //   } else if (selectVisaProvider) {
    //     return indexData.visa_provider === selectVisaProvider;
    //   } else {
    //     return [];
    //   }
    // });

    // setFiltered(filteredData);
  };

  const visaProviderFilter = (e) => {
    const visaProvider = e.target.value;
    console.log("Selected Visa Provider:", visaProvider);
    setSelectVisaProvider(visaProvider);

    // if (!selectedStatus && !visaProvider) {
    //   setFiltered([]);
    //   return;
    // }

    // const filteredData = list.filter((indexData) => {
    //   if (selectedStatus && visaProvider) {
    //     return (
    //       indexData.client_name === selectedStatus &&
    //       indexData.visa_provider === visaProvider
    //     );
    //   } else if (selectedStatus) {
    //     return indexData.client_name === selectedStatus;
    //   } else if (visaProvider) {
    //     return indexData.visa_provider === visaProvider;
    //   } else {
    //     return true; // No filters applied, show all data
    //   }
    // });

    // setFiltered(filteredData);
  };

  const handleCheckboxChange = (event, employee_id, listItem) => {
    const isChecked = event.target.checked;

    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true; // Set the checkbox state to true
      } else {
        delete nextState[employee_id]; // Remove the entry for unchecked checkboxes
      }
      console.log("Checked Items:", nextState);
      return nextState;
    });

    SetListData((prevItemList) => {
      const updatedList = isChecked
        ? [...prevItemList, listItem]
        : prevItemList.filter((item) => item.employee_id !== employee_id);
      console.log("Updated List:", updatedList);
      return updatedList;
    });
    console.log("Updated List Data list:", datalist);
  };

  const LicencePopOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setPopUp(true);
    }
  };

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(filter || []);

  const callApi = () => {
    callBack();
    setCheckedItems({});
    // setIndex(1);
  };

  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => LicencePopOpen()}
        >
          <p>Upload Licence Type</p>
        </button>

        <Search
          searchKey={["employee_id", "visa_reference_number", "border_number"]}
          setSearchWords={setSearchWords}
        />
        <FilterDropDown
          onChange={visaProviderFilter}
          title={"Visa Provider"}
          url={`/sadaad/visa-providers/`}
          token={token}
          selectedStatus={selectVisaProvider}
        />
        <FilterDropDown
          onChange={onChangeValue}
          title={"Client"}
          url={`/sadaad/clients`}
          token={token}
          selectedStatus={selectedStatus}
        />
        <div className="gap-2 items-center flex flex-row"></div>
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>

      <CountPerPage />
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh] ">
          <div className="sticky top-0 z-10 bg-white min-w-[2450px]">
            <div className="grid grid-cols-table-drivingLicenceApply gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-table-drivingLicenceApply gap-5 p-6 bg-white text-center">
            {currentList.map((listItem, index) => (
              <React.Fragment key={index}>
                <PaginationIndex index={index} />
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.employee_id || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.name || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.actual_profession || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.visa_profession || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.visa_provider || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.sponsor || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.client_name || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.iqama_number || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.license_type || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.apply_date || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.issue_date || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.expiry_date || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.valid_days || "-"}
                  />
                </p>
                {selectedStatus !== "" &&
                selectVisaProvider !== "" &&
                filter.length > 0 ? (
                  <div>
                    <input
                      key={listItem.employee_id}
                      type="checkbox"
                      checked={checkedItems[listItem.employee_id] || false}
                      onChange={(event) =>
                        handleCheckboxChange(
                          event,
                          listItem.employee_id,
                          listItem
                        )
                      }
                    />
                  </div>
                ) : (
                  <></>
                )}

                <hr
                  className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      <Pagination />

      {Popup ? (
        <LicenceTypePopUp
          token={token}
          list={datalist}
          PopUp={Popup}
          setPopUp={setPopUp}
          url={"/drivingLicense/updateLicenseType"}
          callBack={callApi}
          flage={false}
        />
      ) : (
        ""
      )}
    </>
  );
}
